// ═══════════════════════════════════════════════════════════════════════════════
// Receipt helper remark translation display helpers (employer view)
// ═══════════════════════════════════════════════════════════════════════════════

import type { ReceiptTranslationMeta } from '@fdh/shared';
import { resolveTranslatedDisplayText } from './translationDisplay';

export const resolveReceiptRemarkDisplay = (
  remark: string,
  translation: ReceiptTranslationMeta | undefined,
  showOriginal: boolean,
): string => resolveTranslatedDisplayText(remark, translation?.fields.remark, showOriginal);

export const receiptRemarkHasTranslation = (
  remark: string,
  translation: ReceiptTranslationMeta | undefined,
): boolean => {
  const trimmed = remark.trim();
  if (trimmed === '') {
    return false;
  }
  return Boolean(translation?.hasTranslation && (translation.fields.remark ?? '').trim() !== '');
};
